import React from "react";
import { OrderableList } from "../../../components/Tables";
import DraggableFile from "./DraggableFile";

interface Props {
  files: server.dto.ESignFile[]
  onEditSaved: (newFileName: string, eSignFileId: number) => void
  onFileDelete: (file: server.dto.ESignFile) => void
  onFileOrderChange: (files: server.dto.ESignFile[]) => void
}

const FilesList = (props: Props) => {
  return <OrderableList
    listId="files"
    items={props.files}
    getKey={f => `${f.eSignFileId}`}
    render={file => <DraggableFile file={file} onSave={props.onEditSaved} />}
    onOrderChanged={props.onFileOrderChange}
    onDelete={props.onFileDelete}
  />;
};

export default FilesList;